import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import MINIList from './MINIList';
import APVList from './APVList';

const CollapsePanel = Collapse.Panel;

const MINIAPVCollapse = ({ token, t, data, type}) => (
  <Collapse>
   {
    type === 'MINI' ? 
      <CollapsePanel header={t('Zobraziť údaje z MINI v čase žiadosti')}>
        <MINIList data={data} token={token} />
      </CollapsePanel>
      :
      <CollapsePanel header={t('Zobraziť údaje z APV v čase žiadosti')}>
        <APVList data={data} token={token} />
      </CollapsePanel>
   }
    
  </Collapse>
)

MINIAPVCollapse.propTypes = {
  token: PropTypes.string.isRequired,
  miniData: PropTypes.object,
  t: PropTypes.func.isRequired
}

export default translate()(MINIAPVCollapse)


// WEBPACK FOOTER //
// ./src/common/components/data-display/MINIAPVCollapse.js